// material
import ModernTable from '../components/ModernTable';
import { useTheme } from '@mui/material/styles';
import { CloudDownload } from '@mui/icons-material';
import { Email } from '@mui/icons-material';
import request from '../../../services/Request';
import Swal from 'sweetalert2';
import { useState, useEffect } from 'react';
import { Box, Typography, Chip, alpha } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

export default function ProdTable(props) {
  const theme = useTheme();
  const { prodInfo } = props;

  const [data, setData] = useState(prodInfo ? prodInfo.nprod : []);

  useEffect(() => {
    setData(prodInfo ? prodInfo.nprod : []);
  }, [prodInfo]);

  const columns = [
    {
      field: 'id.name',
      title: 'Name',
      cellStyle: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '50%',
      },
      render: (rowData) => (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {rowData.id.name}
        </Typography>
      ),
    },
    {
      field: 'id.upc',
      title: 'UPC/SKU',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
          {rowData.id.upc}
        </Typography>
      ),
    },
    {
      field: 'id.price',
      title: 'Price',
      render: (rowData) => (
        <Chip
          label={rowData.id.price.toFixed(2)}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
  ];

  return (
    <ModernTable
      columns={columns}
      data={data}
      title="Products not sold"
      options={{
        search: false,
        actionsColumnIndex: -1,
        pageSize: 3,
      }}
    />
  );
}
